import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcCamera = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.51177 4.03846C6.89995 3.10684 7.81021 2.5 8.81947 2.5H11.6575C12.6996 2.5 13.6324 3.14643 13.9983 4.12219L14.1247 4.45927C14.2467 4.78452 14.5577 5 14.905 5H15.8334C17.2141 5 18.3334 6.11929 18.3334 7.5V15C18.3334 16.3807 17.2141 17.5 15.8334 17.5H4.16669C2.78598 17.5 1.66669 16.3807 1.66669 15V7.5C1.66669 6.11929 2.78598 5 4.16669 5H5.55558C5.89199 5 6.19542 4.79772 6.32481 4.48718L6.51177 4.03846ZM7.50002 10.8333C7.50002 9.45262 8.61931 8.33333 10 8.33333C11.3807 8.33333 12.5 9.45262 12.5 10.8333C12.5 12.214 11.3807 13.3333 10 13.3333C8.61931 13.3333 7.50002 12.214 7.50002 10.8333ZM10 6.66667C7.69883 6.66667 5.83335 8.53215 5.83335 10.8333C5.83335 13.1345 7.69883 15 10 15C12.3012 15 14.1667 13.1345 14.1667 10.8333C14.1667 8.53215 12.3012 6.66667 10 6.66667Z",
		fill: "white"
	})
});
export default SvgIcCamera;
